export const langConfig = ["en", "es", "fr"];
